import { render, staticRenderFns } from "./DentistAssociate.vue?vue&type=template&id=e81bbd8c&scoped=true"
import script from "./DentistAssociate.vue?vue&type=script&lang=js"
export * from "./DentistAssociate.vue?vue&type=script&lang=js"
import style0 from "./DentistAssociate.vue?vue&type=style&index=0&id=e81bbd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81bbd8c",
  null
  
)

export default component.exports